import * as React from "react";

import { ROUTE_URL } from "../components/common/baseConst";
import { URL_PREFIX } from "../components/common/const";
import AnnouncementPermissionsGuard from "../components/component-announcement/permissionsGuard";
import AreaCondoSpecialistPermissionGuard from "../components/component-area-condo-specialist/common/permissionsGuard";
import SpecialistReportPermissionGuard from "../components/component-specialist-report/permissionsGuard";
import PaymentPermissionGuard from "../components/common/payment/PermissionsGuard";
import DynamicPricingGuard from "../components/component-dynamic-pricing/permissionsGuard";
import LeadsPermissionGuard from "../components/component-leads/common/permissionGuard";
import featureToggles from "../config/feature-toggles.malaysia";

import {
  AddListing,
  AgencyBranch,
  AgencyBranchCreation,
  AgencyBranchEdit,
  AgencyBranchList,
  Agentools,
  Allocations,
  AllocationIndividual,
  AllocationPage,
  AllocationPlan,
  AllocationReport,
  AnnouncementsPage,
  AnnouncementDetails,
  AnnouncementListPage,
  AreaCondoSpecialist,
  BatchUpload,
  Blacklists,
  Brickz,
  CreateAnnouncement,
  Dashboard,
  DescriptionAndMedia,
  EditAnnouncement,
  EditListing,
  EditOfUpgrade,
  Enquiries,
  EnquiryManagement,
  EnquiryManagementOverview,
  EnquirySettings,
  Fsbo,
  IQAgent,
  Leads,
  LeadDetail,
  Listings,
  ListingDetailsView,
  ListingPage,
  LocationInfo,
  MarketAnalytics,
  Notification,
  Overview,
  Performances,
  SpecialistReport,
  Plans,
  PreviewAnnouncement,
  PreviewListing,
  PropertyDetails,
  PropertyWanted,
  Quality,
  QualityAddress,
  QualityImage,
  RateLimits,
  Reporting,
  Reportings,
  ScheduledManager,
  Subscription,
  SuccessPage,
  UpgradeAndReview,
  Watermark,
  SpecialistSlotList,
  SpecialistSlotEdit,
  SpecialistSlotEditSuccess,
  AreaCondoSpecialistAdd,
  AreaCondoSpecialistAddSuccess,
  AreaCondoSpecialistUpgradeListing,
  CreditUsage,
  CreditBrickz,
  SubscriptionRenewal,
  PaymentResult,
  PaymentHistory,
  DynamicPricing,
  LeadsV2,
  LeadDetailV2,
  LeadInterestShownHistory,
  MarketWatch,
  AddListingV2,
  LocationInfoV2,
  PropertyDetailsV2,
} from "./pages";

export const addListingRoutes = [
  {
    path: URL_PREFIX + "/add-listing/:stepName(listing-details)",
    exact: true,
    component: AddListing,
    routes: [
      {
        name: "listingDetails",
        path: URL_PREFIX + "/add-listing/listing-details",
        exact: true,
        component: ListingDetailsView,
      },
    ],
  },
  {
    path: URL_PREFIX + "/add-listing/success/:id(\\d+)",
    exact: true,
    component: SuccessPage,
  },
  {
    path:
      URL_PREFIX +
      "/add-listing/:stepName(listing-details|location|property-details|description-and-media|upgrade-and-review)/:id(\\d+)",
    exact: true,
    component: AddListing,
    routes: [
      {
        name: "listingDetails",
        path: URL_PREFIX + "/add-listing/listing-details/:id(\\d+)",
        exact: true,
        component: ListingDetailsView,
      },
      {
        name: "location",
        path: URL_PREFIX + "/add-listing/location/:id(\\d+)",
        exact: true,
        component: LocationInfo,
      },
      {
        name: "propertyDetails",
        path: URL_PREFIX + "/add-listing/property-details/:id(\\d+)",
        exact: true,
        component: PropertyDetails,
      },
      {
        name: "descriptionAndMedia",
        path: URL_PREFIX + "/add-listing/description-and-media/:id(\\d+)",
        exact: true,
        component: DescriptionAndMedia,
      },
      {
        name: "upgradeAndReview",
        path: URL_PREFIX + "/add-listing/upgrade-and-review/:id(\\d+)",
        exact: true,
        component: UpgradeAndReview,
      },
    ],
  },
  {
    name: "previewListing",
    path: URL_PREFIX + "/add-listing/preview-Listing/:id(\\d+)",
    exact: true,
    component: PreviewListing,
  },
];

export const addListingV2Routes = [
  {
    path: URL_PREFIX + "/add-listing/:stepName(location)",
    exact: true,
    component: AddListingV2,
    routes: [
      {
        name: "locationV2",
        path: URL_PREFIX + "/add-listing/location",
        exact: true,
        component: LocationInfoV2,
      },
    ],
  },
  {
    path: URL_PREFIX + "/add-listing/success/:id(\\d+)",
    exact: true,
    component: SuccessPage,
  },
  {
    path:
      URL_PREFIX +
      "/add-listing/:stepName(location|property-details|description-and-media|upgrade-and-review)/:id(\\d+)",
    exact: true,
    component: AddListingV2,
    routes: [
      {
        name: "locationV2",
        path: URL_PREFIX + "/add-listing/location/:id(\\d+)",
        exact: true,
        component: LocationInfoV2,
      },
      {
        name: "propertyDetailsV2",
        path: URL_PREFIX + "/add-listing/property-details/:id(\\d+)",
        exact: true,
        component: PropertyDetailsV2,
      },
      {
        name: "descriptionAndMedia",
        path: URL_PREFIX + "/add-listing/description-and-media/:id(\\d+)",
        exact: true,
        component: DescriptionAndMedia,
      },
      {
        name: "upgradeAndReview",
        path: URL_PREFIX + "/add-listing/upgrade-and-review/:id(\\d+)",
        exact: true,
        component: UpgradeAndReview,
      },
    ],
  },
  {
    name: "previewListing",
    path: URL_PREFIX + "/add-listing/preview-Listing/:id(\\d+)",
    exact: true,
    component: PreviewListing,
  },
];

export const editListingRoutes = [
  {
    path:
      URL_PREFIX +
      "/edit-listing/:stepName(listing-details|location|property-details|description-and-media|upgrade-and-review)/:id(\\d+)",
    exact: true,
    component: EditListing,
    routes: [
      {
        name: "listingDetails",
        path: URL_PREFIX + "/edit-listing/listing-details/:id(\\d+)",
        exact: true,
        component: ListingDetailsView,
      },
      {
        name: "location",
        path: URL_PREFIX + "/edit-listing/location/:id(\\d+)",
        exact: true,
        component: LocationInfo,
      },
      {
        name: "propertyDetails",
        path: URL_PREFIX + "/edit-listing/property-details/:id(\\d+)",
        exact: true,
        component: PropertyDetails,
      },
      {
        name: "descriptionAndMedia",
        path: URL_PREFIX + "/edit-listing/description-and-media/:id(\\d+)",
        exact: true,
        component: DescriptionAndMedia,
      },
      {
        name: "upgradeAndReview",
        path: URL_PREFIX + "/edit-listing/upgrade-and-review/:id(\\d+)",
        exact: true,
        component: EditOfUpgrade,
        isUpgrade: true,
      },
    ],
  },
];

export const editListingV2Routes = [
  {
    path:
      URL_PREFIX +
      "/edit-listing/:stepName(location|property-details|description-and-media|upgrade-and-review)/:id(\\d+)",
    exact: true,
    component: EditListing,
    name: "listingV2",
    routes: [
      {
        name: "locationV2",
        path: URL_PREFIX + "/edit-listing/location/:id(\\d+)",
        exact: true,
        component: LocationInfoV2,
      },
      {
        name: "propertyDetailsV2",
        path: URL_PREFIX + "/edit-listing/property-details/:id(\\d+)",
        exact: true,
        component: PropertyDetailsV2,
      },
      {
        name: "descriptionAndMedia",
        path: URL_PREFIX + "/edit-listing/description-and-media/:id(\\d+)",
        exact: true,
        component: DescriptionAndMedia,
      },
      {
        name: "upgradeAndReview",
        path: URL_PREFIX + "/edit-listing/upgrade-and-review/:id(\\d+)",
        exact: true,
        component: EditOfUpgrade,
        isUpgrade: true,
      },
    ],
  },
];

const watermarkRoute = [
  {
    path: URL_PREFIX + "/watermark",
    name: "watermark",
    exact: true,
    component: Watermark,
  },
];

const pageRoute = [
  {
    name: "listings",
    exact: true,
    path: URL_PREFIX + "/listings",
    component: Listings,
  },
  {
    name: "agentools",
    exact: true,
    path: URL_PREFIX + "/search-properties",
    component: Agentools,
  },
  {
    name: "dashboard",
    exact: true,
    path: URL_PREFIX + "/dashboard",
    component: Dashboard,
  },
  {
    name: "notifications",
    exact: true,
    path: URL_PREFIX + "/notifications",
    component: Notification,
  },
  {
    path: URL_PREFIX + "/dashboard/announcements",
    exact: true,
    component: AnnouncementsPage,
  },
  {
    path: URL_PREFIX + "/dashboard/announcements/:id(\\d+)",
    exact: true,
    component: AnnouncementDetails,
  },
  {
    path: URL_PREFIX + "/add-announcement",
    exact: true,
    component: AnnouncementPermissionsGuard(CreateAnnouncement),
  },
  {
    path: URL_PREFIX + "/preview-announcement/:id",
    exact: true,
    component: AnnouncementPermissionsGuard(PreviewAnnouncement),
  },
  {
    path: URL_PREFIX + "/announcements",
    exact: true,
    component: AnnouncementPermissionsGuard(AnnouncementListPage),
  },
  {
    path: URL_PREFIX + "/edit-announcement/:id",
    exact: true,
    component: AnnouncementPermissionsGuard(EditAnnouncement),
  },
  {
    name: "brickz",
    exact: true,
    path: URL_PREFIX + "/brickz",
    component: Brickz,
  },
  {
    name: "home-report",
    exact: true,
    path: URL_PREFIX + "/iq-agent",
    component: IQAgent,
  },
  {
    name: "specialistReport",
    exact: true,
    path: URL_PREFIX + "/reportings/specialist",
    component: SpecialistReportPermissionGuard(SpecialistReport),
  },
  {
    name: "reportings",
    exact: true,
    path: URL_PREFIX + "/reportings/:tabName(performance)",
    component: Reportings,
    routes: [
      {
        path: URL_PREFIX + "/reportings/performance",
        exact: true,
        component: Performances,
      },
    ],
  },
  {
    name: "plans",
    exact: true,
    path: URL_PREFIX + "/plans/:tabName(subscription|allocation)",
    component: Plans,
    routes: [
      {
        path: URL_PREFIX + "/plans/subscription",
        exact: true,
        component: Subscription,
      },
      {
        path: URL_PREFIX + "/plans/allocation",
        exact: true,
        component: AllocationPlan,
      },
    ],
  },
  {
    path: ROUTE_URL.plans.creditUsage,
    name: "credit-usage",
    exact: true,
    component: CreditUsage,
  },
  {
    exact: true,
    path: URL_PREFIX + "/listings/batch-upload",
    component: BatchUpload,
  },
  {
    path: URL_PREFIX + "/listing/:tabName(overview|reporting)/:id(\\d+)",
    exact: true,
    component: ListingPage,
    routes: [
      {
        path: URL_PREFIX + "/listing/overview/:id(\\d+)",
        exact: true,
        component: Overview,
      },
      {
        path: URL_PREFIX + "/listing/reporting/:id(\\d+)",
        exact: true,
        component: Reporting,
      },
    ],
  },
  {
    path: URL_PREFIX + "/agency-branch/:behavior(create|list)",
    exact: true,
    component: AgencyBranch,
    name: "createBranch",
    routes: [
      {
        path: URL_PREFIX + "/agency-branch/create",
        component: AgencyBranchCreation,
      },
      {
        path: URL_PREFIX + "/agency-branch/list",
        component: AgencyBranchList,
      },
      {
        path: URL_PREFIX + "/agency-branch/edit/:id(\\d+)",
        component: AgencyBranchEdit,
      },
    ],
  },
  {
    path: URL_PREFIX + "/agency-branch/edit/:id(\\d+)",
    exact: true,
    name: "editBranch",
    component: AgencyBranch,
    routes: [
      {
        path: URL_PREFIX + "/agency-branch/edit/:id(\\d+)",
        component: AgencyBranchEdit,
      },
    ],
  },
  {
    path: URL_PREFIX + "/allocations",
    name: "allocations",
    exact: true,
    component: Allocations,
  },
  {
    path: URL_PREFIX + "/allocations/report/:orgId",
    exact: true,
    component: AllocationReport,
  },
  {
    path: URL_PREFIX + "/allocations/individual/:orgId",
    name: "individualAllocations",
    exact: true,
    component: AllocationIndividual,
  },
  {
    path: URL_PREFIX + "/allocations/allocation/",
    exact: true,
    component: AllocationPage,
  },
  {
    path: URL_PREFIX + "/enquiry-settings",
    name: "enquirySettings",
    exact: true,
    component: EnquirySettings,
  },
  {
    path: URL_PREFIX + "/fsbo-alerts",
    name: "fsboAlert",
    exact: true,
    component: Fsbo,
  },
  {
    name: "leads",
    exact: true,
    path: URL_PREFIX + "/leads",
    component: Leads,
  },
  {
    name: "leadsV2",
    exact: true,
    path: URL_PREFIX + "/v2/leads",
    component: LeadsPermissionGuard(LeadsV2),
  },
  {
    name: "leadInterestShownHistoryV2",
    exact: true,
    path: URL_PREFIX + "/v2/lead/:id/interestShownHistory",
    component: LeadsPermissionGuard(LeadInterestShownHistory),
  },
  {
    name: "leadDetailV2",
    exact: true,
    path: URL_PREFIX + "/v2/lead/:id",
    component: LeadsPermissionGuard(LeadDetailV2),
  },
  {
    path: URL_PREFIX + "/lead/:id(\\d+)",
    name: "leadDetail",
    exact: true,
    component: LeadDetail,
  },
  {
    path: URL_PREFIX + "/property-wanted",
    name: "propertyWanted",
    exact: true,
    component: PropertyWanted,
  },
  {
    path: ROUTE_URL.marketAnalytics.landing,
    name: "marketAnalytics",
    component: MarketAnalytics,
  },
  {
    path: ROUTE_URL.marketWatch.landing,
    name: "marketWatch",
    component: MarketWatch,
  },
  {
    path: ROUTE_URL.scheduledManager.default,
    name: "scheduledManager",
    exact: true,
    component: ScheduledManager,
  },
  {
    path: URL_PREFIX + "/enquiry-management/:tabName",
    exact: true,
    name: "enquiryManagement",
    component: EnquiryManagement,
    routes: [
      {
        path: URL_PREFIX + "/enquiry-management/enquiries",
        component: Enquiries,
      },
      {
        path: URL_PREFIX + "/enquiry-management/blacklists",
        component: Blacklists,
      },
      {
        path: URL_PREFIX + "/enquiry-management/rate-limits",
        component: RateLimits,
      },
      {
        path: URL_PREFIX + "/enquiry-management/overview",
        component: EnquiryManagementOverview,
      },
    ],
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.default,
    name: "areaCondoSpecialist",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(AreaCondoSpecialist),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.create,
    name: "areaCondoSpecialistCreate",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(AreaCondoSpecialistAdd),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.createSuccess + "/:id(\\d+)",
    name: "areaCondoSpecialistCreateSuccess",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(
      AreaCondoSpecialistAddSuccess
    ),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.upgradeListing,
    name: "areaCondoSpecialistUpgradeListing",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(
      AreaCondoSpecialistUpgradeListing
    ),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.slotList,
    name: "specialistSlotList",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(SpecialistSlotList),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.slotEdit + "/:id(\\d+)",
    name: "specialistSlotEdit",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(SpecialistSlotEdit),
  },
  {
    path: ROUTE_URL.areaCondoSpecialist.slotEditSuccess + "/:id(\\d+)",
    name: "specialistSlotEditSuccess",
    exact: true,
    component: AreaCondoSpecialistPermissionGuard(SpecialistSlotEditSuccess),
  },
  {
    name: "creditBrickz",
    exact: true,
    path: URL_PREFIX + "/credit-brickz",
    component: PaymentPermissionGuard(CreditBrickz),
  },
  {
    name: "subscriptionRenewal",
    exact: true,
    path: URL_PREFIX + "/subscription-renewal",
    component: PaymentPermissionGuard(SubscriptionRenewal),
  },
  {
    path: URL_PREFIX + "/payment-result",
    name: "paymentResult",
    exact: true,
    component: PaymentPermissionGuard(PaymentResult),
  },
  {
    path: URL_PREFIX + "/payment-history",
    name: "paymentHistory",
    exact: true,
    component: PaymentPermissionGuard(PaymentHistory),
  },
  {
    path: URL_PREFIX + "/dynamic-pricing",
    name: "dynamicPricing",
    exact: true,
    component: DynamicPricingGuard(DynamicPricing),
  },
] as RouteType[];
const userManagementRouter = [
  {
    path: "/users/logout",
    exact: true,
    name: "log-out",
  },
  {
    path: "/users/user-profile",
    exact: true,
    name: "agent",
  },
  {
    path: "/users",
    exact: true,
    name: "team",
  },
  {
    name: "subscriptions",
    exact: true,
    path: "/subscriptions",
  },
  {
    name: "setting",
    exact: true,
    path: "/users/settings/account",
  },
  {
    name: "dashboard",
    exact: true,
    path: URL_PREFIX + "/dashboard",
    component: Dashboard,
  },
  {
    path: URL_PREFIX + "/dashboard/announcements",
    exact: true,
    component: AnnouncementsPage,
  },
  {
    path: URL_PREFIX + "/dashboard/announcements/:id(\\d+)",
    exact: true,
    component: AnnouncementDetails,
  },
  {
    name: "reportings",
    exact: true,
    path: URL_PREFIX + "/reportings/:tabName(performance)",
    component: Reportings,
    routes: [
      {
        path: URL_PREFIX + "/reportings/performance",
        exact: true,
        component: Performances,
      },
    ],
  },
  {
    name: "quality-dashboard",
    exact: true,
    path: URL_PREFIX + "/quality-dashboard",
    component: Quality,
  },
  {
    name: "quality-verification-image",
    exact: true,
    path: URL_PREFIX + "/quality-verification-image/:id",
    component: QualityImage,
  },
  {
    name: "quality-verification-address",
    exact: true,
    path: URL_PREFIX + "/quality-verification-address/:id",
    component: QualityAddress,
  },
  {
    name: "plans",
    exact: true,
    path: URL_PREFIX + "/plans/:tabName(subscription|allocation)",
    component: Plans,
    routes: [
      {
        path: URL_PREFIX + "/plans/subscription",
        exact: true,
        component: Subscription,
      },
      {
        path: URL_PREFIX + "/plans/allocation",
        exact: true,
        component: AllocationPlan,
      },
    ],
  },
] as RouteType[];

if (featureToggles.WATERMARK) {
  pageRoute.push(...watermarkRoute);
}

if (featureToggles.LSOT) {
  pageRoute.push(...addListingV2Routes);
  pageRoute.push(...editListingV2Routes);
} else {
  pageRoute.push(...addListingRoutes);
  pageRoute.push(...editListingRoutes);
}

export type RouteType = {
  path: string;
  component: React.ComponentType<any>;
  routes?: RouteType[];
  name?: string;
  exact?: boolean;
};

export const routeConfig = pageRoute.concat(userManagementRouter);
